// eslint-disable-next-line import/prefer-default-export
export const urlsModule = ({
  urlsModule: {
    urls, totalRecords, fetchingUrlsError, fetchingUrls,
  },
}) => ({
  urls, totalRecords, fetchingUrlsError, fetchingUrls,
})
